// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.GaugeAvailableFunction.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { FUNCTION } from './Izenda.ReportPartFieldConstants';
import { CHART_TYPE } from 'logic/data/Izenda.ChartDefaultConfig';
import { concat } from 'lodash/fp';
import { isChartType } from 'logic/data/Izenda.ReportPartChartConstants';

const availableSeparator = {
  SUPPORTED: {
    Datetime: [FUNCTION.GROUP, FUNCTION.GROUP_DAYS_OLD],
    DEFAULT: [FUNCTION.GROUP]
  }
};

const unsupportedEmpty = {
  UNSUPPORTED: {
    DEFAULT: [FUNCTION.NONE]
  }
};

const groupFunctions = [FUNCTION.GROUP, FUNCTION.GROUP_DAYS_OLD];
const emptyFunctions = [FUNCTION.NONE];

export default function resolveAvailableFunction(type: string) {
  const isHeatMapStyle = isChartType(type, CHART_TYPE.HeatMap);
  const isBubbleOrScatterStyle = isChartType(type, CHART_TYPE.Bubble, CHART_TYPE.Scatter);
  const isOthersStyles = isChartType(
    type,
    CHART_TYPE.Column,
    CHART_TYPE.Bar,
    CHART_TYPE.Area,
    CHART_TYPE.Line,
    CHART_TYPE.Pie,
    CHART_TYPE.Funnel,
    CHART_TYPE.Donut,
    CHART_TYPE.Combination,
    CHART_TYPE.TreeMap,
    CHART_TYPE.Waterfall,
    CHART_TYPE.Sparkline
  );

  if (isHeatMapStyle)
    return {
      labels: unsupportedEmpty,
      values: unsupportedEmpty,
      valuesLabels: unsupportedEmpty
    };

  if (isBubbleOrScatterStyle)
    return {
      labels: unsupportedEmpty,
      values: unsupportedEmpty,
      valuesLabels: unsupportedEmpty,
      bubbleSize: {
        UNSUPPORTED: {
          DEFAULT: concat(emptyFunctions, groupFunctions)
        }
      }
    };

  if (isOthersStyles)
    return {
      labels: unsupportedEmpty,
      values: {
        UNSUPPORTED: {
          DEFAULT: concat(emptyFunctions, groupFunctions)
        }
      },
      separators: availableSeparator
    };

  return {};
}



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ChartAvailableFunction.js